import { TypePinMessages, IVerifyPinParams } from '../types/pin.type';

export const pinMessages: TypePinMessages = {
  notConsecutiveText: 'El PIN no puede ser números ascendentes',
  notDescendingConsecutiveNumbers: 'El PIN no puede ser números descendentes',
  notEqualsNumbers: 'El PIN no puede tener 3 o más números iguales',
};

export const verifyPinSecurity = (
  verifyPinParams: Partial<IVerifyPinParams>
): string => {
  const params = {
    pin: '',
    length: 4,
    blacklist: [],
    messages: pinMessages,
    ...verifyPinParams,
  };

  if (isNaN(Number(params.pin || 0))) {
    return 'El PIN no debe contener letras';
  }
  params.pin = params.pin.toString();

  if (params.blacklist.length > 0) {
    const pinRuleExits = params.blacklist.find((a) => {
      return a.pin === params.pin;
    });

    if (pinRuleExits) {
      return pinRuleExits.message;
    }
  }

  if (params.pin.length < params.length)
    return `El PIN no puede ser menor que ${params.length} dígitos`;
  else if (params.pin.length > params.length)
    return `El PIN no puede ser más de ${params.length} dígitos`;

  const arrayPin = params.pin.split('').map((item) => parseInt(item));

  const isSecuencialPin = arrayPin.every((currentNumber, index) => {
    if (index == 0) return true;
    const beforeNumber = arrayPin[index - 1];

    return currentNumber - beforeNumber === 1;
  });

  if (isSecuencialPin) return `${params.messages.notConsecutiveText}`;

  const isSecuencialDescendantPin = arrayPin.every((currentNumber, index) => {
    if (index == 0) return true;
    const beforeNumber = arrayPin[index - 1];

    return currentNumber - beforeNumber === -1;
  });

  if (isSecuencialDescendantPin)
    return `${params.messages.notDescendingConsecutiveNumbers}`;

  const limit = 3;
  const isEqualsNumberPin =
    arrayPin.reduce((acc: boolean[], cur, ind, arr) => {
      if (ind > 0) {
        if (cur === arr[ind - 1]) {
          acc.push(true);
        } else {
          if (acc.length < limit - 1) {
            acc = [];
          }
        }
      }
      return acc;
    }, []).length >=
    limit - 1;

  if (isEqualsNumberPin) return `${params.messages?.notEqualsNumbers || ''}`;

  return '';
};
